export default __webpack_public_path__ + "static/media/ava-05.ba493d55.png";